import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal, ResourceList, TextField, Thumbnail, DropZone, Icon, Heading, Banner } from '@shopify/polaris';

import { NoteMajorMonotone } from '@shopify/polaris-icons'

const propTypes = {
  open: PropTypes.bool,
  loading: PropTypes.bool,

  onUpload: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,

  importFile: PropTypes.object,
  onDrop: PropTypes.func.isRequired,
  onDeleteFile: PropTypes.func.isRequired,
  
  errors: PropTypes.array,
  dropZoneLabel: PropTypes.string,

  successMessage: PropTypes.string,
  onDismissMessage: PropTypes.func,
}

const defaultProps = {
  loading: false,
  errors: [],
  successMessage: "",
}

// TODO FUTURE SUPER optimization of using something like a hook to get all the state functions or something like that to save the trouble of defining handleImportDelete/importDrop etc
const ImportFileModal = (props) => {
  // console.log("ImportFileModal", props)
  return (
    <Modal
      open={props.open}
      size="Full"
      large
      title="Importar desde un archivo"
      onClose={ props.onCancel }

      primaryAction={{
        content: I18n.t("actions.upload"),
        onAction: props.onUpload,
        loading: props.loading,
        disabled: !props.importFile
      }}
      secondaryActions={[
        {
          content: I18n.t("actions.cancel"),
          onAction: props.onCancel,
          loading: props.loading,
        },
      ]}
    >
      <Modal.Section>
        { props.children }
        <DropZone 
          label={ props.dropZoneLabel }
          allowMultiple={true}
          accept=".xlsx,.csv"
          onDrop={ props.onDrop }>
          { props.importFile &&
            <div className="flex justifyStart m10">
              <Icon
                source={NoteMajorMonotone}
                onDelete={props.onDeleteFile}
              />
              <div className="flexContainer ml8">
                <Heading>
                  { props.importFile.name }
                </Heading>
              </div>
            </div>
          }
        </DropZone>

        { props.errors.length > 0 &&
          <div className="mt10">
            <Banner
              title="Por favor revise los errores y corrija el documento."
              status="critical"
              onDismiss={ props.onDismissMessage }
            >
              { props.errors.map(( error, index ) =>
                <p key={index}>{error}</p>
              )}
            </Banner>
          </div>
        }
        { props.successMessage && 
          <div className="mt10">
            <Banner title="¡Éxito!" status="success" onDismiss={ props.onDismissMessage }>
              { props.successMessage }
            </Banner>
          </div>
        }
      </Modal.Section>
    </Modal>
  )
};

ImportFileModal.propTypes = propTypes;
ImportFileModal.defaultProps = defaultProps;

export default ImportFileModal;